import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Select,
  MenuItem,
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
  Grid,
  Avatar,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAssignedLeads,
  updateLeadStatus,
  closeLead,
} from "../redux/callerSlice/leadsSlice";

const AssignedLeads = () => {
  const dispatch = useDispatch();
  const { leads, loading } = useSelector((state) => state.leads);
  const [search, setSearch] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [amountReceived, setAmountReceived] = useState("");
  const [paymentProof, setPaymentProof] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    console.log("Fetching assigned leads...");
    dispatch(fetchAssignedLeads());
  }, [dispatch]);

  useEffect(() => {
    console.log("Redux State Leads:", leads);
  }, [leads]);

  const handleStatusChange = (id, newStatus) => {
    if (newStatus === "Closed") {
      setSelectedLead(id);
      setOpenDialog(true);
    } else {
      let remark = prompt("Enter a remark:") || "Status changed";
      dispatch(updateLeadStatus({ id, newStatus, remark }));
    }
  };

  const handleSubmitCloseLead = () => {
    if (!amountReceived || !paymentProof) {
      alert("Amount and proof required!");
      return;
    }
    setIsSubmitting(true);
    dispatch(closeLead({ id: selectedLead, amountReceived, paymentProof }))
      .then(() => {
        setIsSubmitting(false);
        setOpenDialog(false);
        setAmountReceived("");
        setPaymentProof(null);
      })
      .catch(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <Box sx={{ borderRadius: 2 }}>
      {loading ? (
        <Box display="flex" justifyContent="center" my={3}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <TextField
            fullWidth
            placeholder="Search by name, email, mobile"
            variant="outlined"
            sx={{ mb: 2 }}
            onChange={(e) => setSearch(e.target.value)}
          />
          <Grid container>
            <Grid item xs={12}>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead sx={{ bgcolor: "#1976D2" }}>
                    <TableRow>
                      <TableCell sx={{ color: "#fff" }}>Name</TableCell>
                      <TableCell sx={{ color: "#fff" }}>Email</TableCell>
                      <TableCell sx={{ color: "#fff" }}>Mobile</TableCell>
                      <TableCell sx={{ color: "#fff" }}>Category</TableCell>
                      <TableCell sx={{ color: "#fff" }}>Status</TableCell>
                      <TableCell sx={{ color: "#fff" }}>
                        Amount Received
                      </TableCell>
                      <TableCell sx={{ color: "#fff" }}>
                        Payment Proof
                      </TableCell>
                      <TableCell sx={{ color: "#fff" }}>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loading ? (
                      <TableRow>
                        <TableCell colSpan={8} align="center">
                          Loading...
                        </TableCell>
                      </TableRow>
                    ) : leads && leads.length > 0 ? (
                      leads
                        .filter((lead) =>
                          `${lead.name} ${lead.email} ${lead.mobile}`
                            .toLowerCase()
                            .includes(search.toLowerCase())
                        )
                        .map((lead) => (
                          <TableRow key={lead._id} hover>
                            <TableCell>
                              <Box display="flex" alignItems="center">
                                <Avatar sx={{ mr: 1 }} /> {lead.name}
                              </Box>
                            </TableCell>
                            <TableCell>{lead.email}</TableCell>
                            <TableCell>{lead.mobile}</TableCell>
                            <TableCell>{lead.category}</TableCell>
                            <TableCell>
                              <Select
                                value={lead.status}
                                onChange={(e) =>
                                  handleStatusChange(lead._id, e.target.value)
                                }
                                fullWidth
                              >
                                <MenuItem value="New">New</MenuItem>
                                <MenuItem value="Contacted">Contacted</MenuItem>
                                <MenuItem value="Interested">
                                  Interested
                                </MenuItem>
                                <MenuItem value="Follow-up">Follow-up</MenuItem>
                                <MenuItem value="Converted">Converted</MenuItem>
                                <MenuItem value="Not Interested">
                                  Not Interested
                                </MenuItem>
                                <MenuItem value="Invalid">Invalid</MenuItem>
                                <MenuItem value="Lost">Lost</MenuItem>
                                <MenuItem value="Closed">Closed</MenuItem>
                              </Select>
                            </TableCell>
                            <TableCell>
                              {lead.amountReceived || "N/A"}
                            </TableCell>
                            <TableCell>
                              {lead.paymentProof ? (
                                <a
                                  href={lead.paymentProof}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  View Proof
                                </a>
                              ) : (
                                "N/A"
                              )}
                            </TableCell>
                            <TableCell>
                              <Button
                                sx={{ textTransform: "capitalize" }}
                                variant="contained"
                                color="primary"
                                onClick={() =>
                                  handleStatusChange(lead._id, "Closed")
                                }
                                disabled={lead.status === "Closed"}
                              >
                                Close Lead
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={8} align="center">
                          No Leads Found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>

          {/* Dialog for Closing Lead */}
          <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
            <DialogTitle>Close Lead</DialogTitle>
            <DialogContent>
              <TextField
                label="Amount Received"
                fullWidth
                type="number"
                value={amountReceived}
                onChange={(e) => setAmountReceived(e.target.value)}
                sx={{ my: 2 }}
              />
              <input
                type="file"
                accept="image/*"
                onChange={(e) => setPaymentProof(e.target.files[0])}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
              <Button
                onClick={handleSubmitCloseLead}
                variant="contained"
                color="primary"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Submit"
                )}
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </Box>
  );
};

export default AssignedLeads;
